export function removeDecimals(value: number) {
  return Math.trunc(value);
}
